export default {
      id: "warning-outline-usage",
      viewBox: "0 0 19 16",
      url: __webpack_public_path__ + "img/icons.svg#warning-outline",
      toString: function () {
        return this.url;
      }
    }